import { Button, Loading } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import useSingleReportCSV from 'Hooks/query-hooks/simulations/useSingleReportCSV';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import { ExportCSVErrorModal } from './ExportCSVErrorModal';

type Props = {
    recordId: string;
    reportProperties: ProcessedSimulationReportFormValues;
};

const ExportCSV = ({ recordId, reportProperties }: Props) => {
    const { t } = useTranslation();
    const [errorModalOpen, setErrorModalOpen] = useState(false);

    const startDate = new Date(reportProperties.start);
    const dateString = `${startDate.toLocaleString('default', {
        month: 'short'
    })} ${startDate.getDate()} ${startDate.getFullYear()}`;
    const fileName = reportProperties.compare?.length
        ? `Compare_Simulation_Rule-Performance_${dateString}_All-Rules_24_Hours`
        : `Simulation_Rule-Performance_${dateString}_All-Rules_24_Hours`;
    const newReport = useSingleReportCSV(parseInt(recordId, 10), fileName);

    const exportCsvAction = () => {
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'View Simulation - Export CSV',
                text: 'Export Opened Simulation'
            }
        });
        newReport.remove();
        newReport.refetch();
    };

    return (
        <>
            {newReport.isInitialLoading ? (
                <Loading size='sm' fillName='orange' />
            ) : (
                <Button
                    variant='secondary'
                    size='small'
                    data-testid='upload-btn'
                    onClick={handleOnClickEvent(exportCsvAction)}
                    onKeyDown={handleKeyEvent(exportCsvAction)}
                    disabled={!reportProperties}
                >
                    {t('Export CSV')}
                </Button>
            )}
            <ExportCSVErrorModal
                isOpen={errorModalOpen}
                closeModal={() => {
                    setErrorModalOpen(false);
                }}
                createReport={() => newReport.refetch()}
            />
        </>
    );
};

export default ExportCSV;
